import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	CardDescription,
} from "@/components/primitives";
import { Calendar, RefreshCw, FileText } from "lucide-react";
import { formatDate } from "@/lib/utils";
import type { Reflection } from "../types";

interface ReflectionSummaryProps {
	reflection: Reflection;
}

export function ReflectionSummary({ reflection }: ReflectionSummaryProps) {
	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm print-hide-summary">
			<CardHeader className="pb-4 border-b bg-gradient-to-r from-blue-50/50 to-indigo-50/50 dark:from-blue-950/20 dark:to-indigo-950/20">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600">
						<FileText className="h-5 w-5 text-white" />
					</div>
					<div className="flex-1">
						<CardTitle className="text-xl sm:text-2xl font-semibold print-hide">
							{reflection.title}
						</CardTitle>
						<div className="flex items-center space-x-4 text-sm text-muted-foreground mt-1 print-hide">
							<div className="flex items-center">
								<Calendar className="h-4 w-4 mr-1" />
								Created {formatDate(reflection.created_at)}
							</div>
							{reflection.updated_at !== reflection.created_at && (
								<div className="flex items-center">
									<RefreshCw className="h-4 w-4 mr-1" />
									Updated {formatDate(reflection.updated_at)}
								</div>
							)}
						</div>
					</div>
				</div>
			</CardHeader>
			{/* {reflection.description && (
        <CardContent className="pt-6">
          <p className="text-foreground leading-relaxed">{reflection.description}</p>
        </CardContent>
      )} */}
		</Card>
	);
}
